export default "__VITE_ASSET__B1pNZl6b__"